import React, { useContext } from "react";
import './CartItems.css';
import CartTotal from "./CartTotal";
import { ShopContext } from "../../context/ShopContext";
import remove_icon from '../assets/cafe/cart_cross_icon.png';
import ScrollToTop from "../../components/util/ScrollToTop";
import { formatPrice } from "../../utils/formatPrice";

const CartItems = () => {

    const { cartItems, removeFromCart } = useContext(ShopContext);

    return (
        <>
            <ScrollToTop />
            <div className="cartitems-container">
                <hr />
                <div className="cartitems">
                    {Object.entries(cartItems).map(([cartKey, item]) => (
                        <React.Fragment key={cartKey}>
                            <div className="cartitem">
                                <img className="cartitem-product-icon" src={item.image} alt="" />
                                <p>{item.name}{item.variantLabel ? ` (${item.variantLabel})` : ""}</p>
                            </div>
                            <div className="cartitem-right">
                                <div className=" cartitem-col">
                                    <p>{formatPrice(item.price)}</p>
                                </div>
                                <div className=" cartitem-col">
                                    <button className="cartitem-quantity">{item.quantity}</button>
                                </div>
                                <div className=" cartitem-col">
                                    <p>{formatPrice(item.price * item.quantity)}</p>
                                </div>
                                <div className=" cartitem-col">
                                    <img className="cartitem-remove-icon" src={remove_icon} onClick={() => { removeFromCart(cartKey) }} alt="" />
                                </div>
                            </div>
                        </React.Fragment>
                    ))}
                </div>
                <hr />
            </div>

            <div className="cartitems-promo-totoal">
                <CartTotal />
            </div>
        </>

    )
}

export default CartItems;
